import { z } from 'zod';

export const issueReportSchema = z.object({
    title: z.string().min(1,  {message: 'Název nesmí být prázdný'}),
    description: z.string().min(1,  {message: 'Popis nesmí být prázdný'}),
});

export type IssueReport = z.infer<typeof issueReportSchema>;

export const defaultIssueReport: IssueReport = {
    title: '',
    description: ''
};